import { AdminRouter } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

messageGroups.push('enums')
messageGroups.push('vehicles')
messageGroups.push('company')

AdminRouter.addRoute({
  name: 'vehicle_additional_prices',
  path: '/vehicle-additional-prices',
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
})
